var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 905.8 405.1",
    style: {
      enableBackground: "new 0 0 905.8 405.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFF00;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#F04F26;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.4,390.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M477.4,136.2h47l-25,134h-47C452.4,270.2,476.9,135.7,477.4,136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M551.4,137.2l-25,133h128l5-35h-79l2-15h72l6-34h-71l2-14h76l6-35C673.4,137.2,551.3,137.3,551.4,137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.9,94.3c-2.3-0.9-4.5-1.7-6.5-2.1C257.4,92.2,259.8,92.8,263.9,94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.5,232.6c-1.1-70.5-55.1-147.5-159.1-187.5c79.4,8.8,123.8,51.1,143.5,75.6C359.1,54.6,292,8.7,214.1,8.7 c-47.6,0-134.2,22-135.8,79.5c-1.1,44,64,69,120,93c50.1,17.1,150.2,69.8,117,159c-9.2,23.3-27.7,39.4-48.6,48.7 c10.4-2.9,20.4-6.7,30-11.2c27.8-18.3,60.6-50.5,60.6-100.5c0-73.1-49.7-105.5-59.4-111.1c-1.1-0.6-1.6-0.9-1.6-0.9 s0.6,0.3,1.6,0.9c10.2,5.8,64.5,39.5,75.4,101.1c4.3,24.1-4.7,47.6-18,67.9c72-86.9-18-215.9-101-243.9 C367,113.9,398.4,204.3,405.5,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M789.4,198.2l88-96h-89l-47,55l-47-55h-92l32,34l0.9,1c21.2,0,38.1,0,38.1,0l-6,34.9l25,27.1l-33.1,36.7 l-4.9,34.3h-26.1l-0.9,1l-22,24h-157l-1,8h239l54-64l54,64h92L789.4,198.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.4,92.2C336,121,419,238.5,363.7,323.8C459.7,220.3,331.6,113.9,257.4,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M253,47.8C351.3,87.9,403,161.6,405.5,229.7C424.2,121.1,310.3,61.6,253,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.4,251.2c-10-9-16-13-16-13v-15c0,0-2.9-9.1-11.5-19.5c-17.5-21.2-54.8-50.2-112.5-35.5c-9-2-26-17-26-37 c-3,8-10,33,6,48c-10,1-17-5-19-13c-3,6-2,15,3,18c-5.1,0.8-10.3,4.7-10,6c3.4,0.5,6.1,1.6,7,4c-0.3,1.3-5.9,4.9-6,8.9 c0.2,52.8,21.4,100.6,55.8,135.4c19.7,19.2,41.7,32.9,60.8,41.7c18.9,8.2,39.4,13.5,60.8,15.3c-5.9-1.7-11.1-4.2-15.5-7.3 c-21-15-69-53-48-107c6-7,6-8,10-7s42.5,17.8,52,23c11,6,13,13,11,22c5-8,11-16,11-29C219.4,275.2,215.4,260.2,205.4,251.2z  M129.4,204.2c2-6,12,1,15,5c12,13,12,13,12,13C149.3,220.7,128.4,222.3,129.4,204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.9,182c23.5,11.4,87.2,48.1,81.5,106.1c-1.9,19-12.5,63.5-74.5,62.5c-25.1-0.4-77.3-16.9-77.4-56 c-9.1,46.8,32.7,79.8,51.9,93.5c4.4,3.1,9.6,5.6,15.5,7.3c0.2,0.1,0.4,0.2,0.6,0.3c19.5,1.6,42.8,0.5,67.8-6.6 c0.2-0.1,0.4-0.2,0.6-0.3c20.9-9.3,39.4-25.4,48.6-48.7C348.1,252.4,251.7,200,200.9,182z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIex);
export default __webpack_public_path__ + "static/media/IEX.4a3e6306280ce9f01285b82c76b16872.svg";
export { ForwardRef as ReactComponent };